import {
  featureSelectors,
  recordingActions,
  recordingsSelectors as nucleusRecordingsSelectors
} from '@lifesize/nucleus';
import _escape from 'lodash/escape';
import _get from 'lodash/get';
import { connect } from 'react-redux';
import actions from 'actions/recordingsActions';
import { actions as ModalActions } from 'actions/modalActions';
import RecordingsToolbar from 'components/Recordings/RecordingsToolbar';
import {
  RecordingRequestObjectFeed,
  RecordingRequestObjectSort,
  RecordingRequestObjectTimeLine,
  RecordingLimits
} from 'constants/recordingsConstants';
import { RecordingRequest } from 'interfaces/RecordingRequest';
import * as RS from 'selectors/recordingsSelectors';
import { Global } from 'state/Global';
import { getNowFormattedString } from 'utils/date-time-utils';
import { ModalTypes } from 'constants/modalConstants';
import { FEATURE_FLAG_SHARE_MEETING_RECORDINGS } from 'constants/featureFlags';
import { getUrlParameter } from 'utils/url-utils';

export interface OwnPropsInterface {
  pageType: RecordingRequestObjectFeed;
}

const mapStateToProps = (state: Global) => {
  const recordingsFeedState = nucleusRecordingsSelectors.recordingsFeed(state);
  const pageNum = RS.selectPageNum(state);
  const recordingsObject = (state.app) ? state.app.get('recordings', null) : null;
  const meetingId = _get(recordingsObject, 'meeting', null);
  let meetingName = _get(recordingsObject, 'meetingName', null);
  return {
    canShareMeetingRecordings: featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_SHARE_MEETING_RECORDINGS),
    canUserModifyRecording: _get(recordingsFeedState, 'selected_meeting.can_edit', false),
    totalCount: parseInt(_get(recordingsFeedState, 'count'), 10),
    pageNum: pageNum,
    limit: RecordingLimits.PAGE_SIZE,
    meetingId: meetingId,
    meetingName: meetingId ? meetingName : null,
    isLoading: _get(recordingsFeedState, 'isFetching') as boolean
  };
};

const mapDispatchToProps = (dispatch: Function, ownProps: OwnPropsInterface) => ({
  handleSearchChange: (searchString: string) => {
    dispatch(actions.handleSortChange(_escape(searchString)));
  },
  handleSearchSelect: (value: string) => {
    // The feed param is determined by the current page type enum
    const vcShareToken = getUrlParameter('msharetoken');
    const requestObject: RecordingRequest = {
      feed: ownProps.pageType,
      page: 1,
      sort: RecordingRequestObjectSort.SORT_DATE,
      timeline: RecordingRequestObjectTimeLine.TIMELINE_ANY,
      offset: 0,
      limit: 12,
      meeting: value,
      timestamp: getNowFormattedString(),
    };
    if (vcShareToken) {
      requestObject.msharetoken = vcShareToken;
    }
    dispatch(actions.setRecordingSearchId(value));
    dispatch(recordingActions.fetchFeed(requestObject));
  },
  handleSearchCleared: () => {
    dispatch(actions.handleLoadRecords(ownProps.pageType));
  },
  handleSortChange: (sortType: string) => {
    dispatch(actions.handleSortChange(sortType));
    dispatch(actions.handleLoadRecords(ownProps.pageType));
  },
  handleDateFilterChange: (dateType: string) => {
    dispatch(actions.handleDateFilterChange(dateType));
    dispatch(actions.handleLoadRecords(ownProps.pageType));
  },
  openUpload: () => {
    dispatch(ModalActions.openModal({ modalType: ModalTypes.UPLOAD_RECORDING }));
  },
  openMeetingShareModal: (payload: Object) =>
    dispatch(ModalActions.openModal({ modalType: ModalTypes.MEETING_SHARE_RECORDING_MODAL, payload })),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecordingsToolbar);
